import React, {useContext, useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {StoreContext} from "../../store/context";
import {DatePicker} from "@material-ui/pickers";
import Paper from "@material-ui/core/Paper";
import moment from "moment";

export default function ConfirmDialog(props) {
    const { state, actions } = useContext(StoreContext);
    const { showConfirmDialog, confirmDialog, confirmDialogAction } = state.generalStates;
    const { displayConfirmDialog } = actions.generalActions;
    const [selectedDate, handleDateChange] = useState(null);
    const [errorMsg, setErrorMsg] = useState("");

    const handleNegativeButton = () => {
        displayConfirmDialog(false);
    };

    const handlePositiveButton = () => {
        if (selectedDate == null && confirmDialog.dateSelection ) {
            setErrorMsg("Please select cancellation date")
            return;
        }
        displayConfirmDialog(false);
        const month = moment(selectedDate).format('MM-YYYY');
        confirmDialogAction(month);
        setErrorMsg("");
        handleDateChange(null);
    };

    const renderDateSelection = () => {
        if (confirmDialog.dateSelection){
            return (
                <div>
                    <DatePicker
                        style={{marginTop: "10px"}}
                        className="date-picker"
                        views={["year", "month"]}
                        label="Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                    <div className="inline-error">{errorMsg}</div>
                </div>

            );
        }
    }

    return (
        <div>
            <Dialog
                open={showConfirmDialog}
                onClose={handleNegativeButton}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{confirmDialog.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div>{confirmDialog.content}</div>
                        <div>{renderDateSelection()}</div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePositiveButton} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNegativeButton} color="primary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}